var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.idlingShow
    ? _c("div", { staticClass: "popup" }, [
        _c("div", { staticClass: "content", attrs: { id: "idlingRealTime" } }, [
          _c(
            "div",
            { staticClass: "title", staticStyle: { paddingLeft: "10px" } },
            [
              _vm._v(
                _vm._s(_vm.$t("language.paySystem.Notice")) +
                  "\n               "
              ),
              _c("div", {
                staticClass: "icon white-close dialog-close",
                on: {
                  click: function($event) {
                    return _vm.close()
                  }
                }
              })
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "idling-body" }, [
            _c("div", { staticClass: "idling-info" }, [
              _vm._v(
                "\n                     " +
                  _vm._s(_vm.$t("language.cloudSync.bePaused")) +
                  "\n                 "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "realtime-idling-bottom" }, [
              _c("div", {
                staticClass: "icon-util ",
                class: _vm.isSelected ? "check-small" : "noIdlingcheck-small",
                staticStyle: {
                  float: "left",
                  marginRight: "5Px",
                  position: "relative",
                  top: "1Px"
                },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.checkBox()
                  }
                }
              }),
              _vm._v(" "),
              _c("div", { staticStyle: { float: "left" } }, [
                _vm._v(_vm._s(_vm.$t("language.cloudSync.dontShow")))
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticStyle: { width: "110Px", float: "right" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.sureTasK()
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("language.common.ok")))]
              )
            ])
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-509b428f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-509b428f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/cloud_transfer_popups/idling_popup.vue
// module id = null
// module chunks = 